import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Header from './Header';
import Footer from './Footer';
import ShopFooter from './ShopFooter';
import WithShopBackground from '../hoc/WithShopBackground';

const Layout = ({ children, backgroundImage, logo, shopLayout, homeUrl, kiosk, noFooter }) => (
  <div>
    <Header homeUrl={homeUrl} kiosk={kiosk} logo={logo} />
    <main
      className={classnames(
        'c-main',
        { 'c-main--shop': shopLayout },
        { 'c-main--no-footer': noFooter }
      )}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="o-wrapper o-wrapper--page u-pb+">
        { children }
      </div>
    </main>
    { !noFooter && (shopLayout ? <ShopFooter /> : <Footer />) }
  </div>
);
Layout.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  shopLayout: PropTypes.bool,
  homeUrl: PropTypes.string,
  kiosk: PropTypes.bool,
  noFooter: PropTypes.bool,
  logo: PropTypes.string,
};
Layout.defaultProps = {
  shopLayout: false,
  homeUrl: '/',
  kiosk: false,
  noFooter: false,
  logo: '',
};

export default WithShopBackground(Layout);



// WEBPACK FOOTER //
// ./src/app/components/Layout.jsx